import Velocity  from '../vendors/velocity.min';

export default function navSearch () {
    const body = $('body'),
        header = $('header'),
        overlay = $('.overlay'),
        timeout = 200;

    const menuBtn  = $('.hamburger-menu'),
        menu = $('.menu-container');

    const searchFormToggleButton = $('.search-trigger'),
        searchFormContainer = document.querySelector('.search-bar-container'),
        searchForm = $('#search-form'),
        inputField = searchForm.find('#search'),
        buttonsWrap = searchForm.find('.buttons-wrap'),
        resetSearch = searchForm.find('#search-reset');

    // Check if element is hidden
    function isHidden (el) {
        const style = window.getComputedStyle(el);

        return (style.display === 'none');
    }

    // Show search form
    function openSearchForm () {
        Velocity(searchFormContainer, 'slideDown', {
            duration: timeout
        });

        closeMenu();

        searchFormToggleButton.addClass('active');
        overlay.addClass('active');
        body.addClass('search-active');

        setTimeout(() => {
            inputField.focus();
        }, timeout);
    }

    // Hide search form
    function hideSearchForm () {
        Velocity(searchFormContainer, 'slideUp', {
            duration: timeout
        });

        setTimeout(() => {
            searchFormToggleButton.removeClass('active');
            overlay.removeClass('active', 'semi-transparent');
            body.removeClass('search-active');
        }, timeout);
    }

    // Check if input !:empty
    function checkSearchInput () {
        if (inputField.val().length > 1) {
            buttonsWrap.addClass('has-value');
        } else {
            buttonsWrap.removeClass('has-value');
        }
    }

    // Check state of search form
    function checkSearchFormState (event) {
        event.preventDefault();
        isHidden(searchFormContainer) ? openSearchForm() : hideSearchForm();
    }

    // Reset form (and hide)
    function resetForm () {
        inputField.val('');
        inputField.focus();
        buttonsWrap.removeClass('has-value');

        // Disable on search page
        if (!header.is('.search-enabled')) {
            hideSearchForm();
        }
    }

    // Open mobile menu
    function openMenu () {
        if (!isHidden(searchFormContainer)) {
            hideSearchForm();
        }

        body.addClass('nav-active');
        menuBtn.addClass('active');

        setTimeout(() => {
            menu.addClass('active');
        }, timeout);
    }

    // Close mobile menu
    function closeMenu () {
        menu.removeClass('active');
        menuBtn.removeClass('active');
        body.removeClass('nav-active');
    }

    // Check state of mobile menu
    function checkMenuState (e) {
        e.preventDefault();
        body.is('.nav-active') ? closeMenu() : openMenu();
    }

    // Reset Navigation on resize above 1024px
    function resetNavState () {
        const ww = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        );

        if (ww >= 1024) {
            closeMenu();
        }
    }

    $(window).resize(resetNavState);

    menuBtn.on('click', checkMenuState);
    overlay.on('click', hideSearchForm);
    searchFormToggleButton.on('click', checkSearchFormState);
    inputField.on('input', checkSearchInput)
    searchForm.on('submit', (e) => {
        if (!buttonsWrap.hasClass('has-value')) {
            e.preventDefault();
        }
    })
    resetSearch.on('click', (e) => {
        e.preventDefault();
        resetForm();
    });
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/header.js